import React, { useEffect } from 'react'
import I18n from 'i18n-js'

import { useSelector, useDispatch } from 'react-redux'
import { setVersion } from './containers/Settings/SettingsAction'

const SwitcherLanguage = (props) => {
	const {
		language,
		version
	} = useSelector(state => state.SettingsReducer)
	const dispatch = useDispatch()

	useEffect(() => {
		let direction = 'ltr'
		if (language === 'fa') {
			direction = 'rtl'
		}
		document.getElementsByTagName('body')[0].dir = direction
		I18n.locale = language
	}, [language])

	useEffect(() => {
		if (!version || version !== '1.0.0') {
			window.localStorage.clear()
			dispatch(setVersion('1.0.0'))
		}
	}, [version])

	return (
		<div>

		</div>
	)
}

export default SwitcherLanguage
